"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _uuid = require("uuid");

var _currencyConverter = require("../store/currencyConverter/currencyConverter.selectors");

var _currencyConverter2 = require("../store/currencyConverter/currencyConverter.actions");

var useConvertCurrency = function useConvertCurrency(params) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var id = (0, _react.useMemo)(function () {
    return (0, _uuid.v4)();
  }, []);
  var conversions = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _currencyConverter.makeGetConversion)(id);
  }, [id]));
  var isLoading = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _currencyConverter.makeGetConversionIsLoading)(id);
  }, [id]));
  var fromCurrencyId = params.fromCurrencyId,
      toCurrencyIds = params.toCurrencyIds,
      price = params.price,
      shouldConvert = params.shouldConvert;
  (0, _react.useEffect)(function () {
    if (shouldConvert) {
      dispatch((0, _currencyConverter2.convertCurrencyRequest)({
        id,
        params: toCurrencyIds.map(function (toCurrencyId) {
          return {
            fromCurrencyId,
            toCurrencyId,
            price
          };
        })
      }));
    }
  }, [id, fromCurrencyId, toCurrencyIds, price, shouldConvert, dispatch]);
  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _currencyConverter2.removeConversion)({
        id
      }));
    };
  }, [dispatch, id]);
  return {
    conversions,
    isLoading
  };
};

var _default = useConvertCurrency;
exports.default = _default;